import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import IntakeFormFields from './IntakeFormFields';

const mono = { fontFamily: "'DM Mono', monospace" };
const sans = { fontFamily: "'DM Sans', sans-serif" };
const serif = { fontFamily: "'Cormorant Garamond', serif" };

export default function IntakeStandalone() {
  const [searchParams] = useSearchParams();
  const engagementId = searchParams.get('engagement_id');
  const [eng, setEng] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!engagementId) {
      setError('No engagement specified.');
      setLoading(false);
      return;
    }
    supabase
      .from('cordis_engagements')
      .select('id,company,client_name,intake_form_answers')
      .eq('id', engagementId)
      .single()
      .then(({ data, error: err }) => {
        if (err || !data) {
          setError('Engagement not found. Please check your link.');
        } else {
          setEng(data);
        }
        setLoading(false);
      });
  }, [engagementId]);

  const handleSubmit = async (answers) => {
    const { error: err } = await supabase
      .from('cordis_engagements')
      .update({
        intake_form_answers: answers,
        intake_form_completed_at: new Date().toISOString(),
      })
      .eq('id', engagementId);

    if (!err) {
      setSubmitted(true);
    } else {
      setError('Failed to save. Please try again.');
    }
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        minHeight: '100vh', background: '#FAFAF8',
      }}>
        <div style={{ ...mono, fontSize: 11, color: '#7A94A8', letterSpacing: '0.14em' }}>
          LOADING...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        minHeight: '100vh', background: '#FAFAF8', padding: 20,
      }}>
        <div style={{ ...sans, fontSize: 15, color: 'rgba(160,40,40,0.85)', textAlign: 'center' }}>
          {error}
        </div>
      </div>
    );
  }

  if (submitted) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        minHeight: '100vh', background: '#FAFAF8', padding: 20,
      }}>
        <div style={{ textAlign: 'center', maxWidth: 440 }}>
          <div style={{
            ...mono, fontSize: 10, letterSpacing: '0.28em',
            color: '#7A5230', textTransform: 'uppercase', marginBottom: 10,
          }}>
            CORDIS GROUP
          </div>
          <div style={{ ...serif, fontSize: 26, fontWeight: 300, color: '#0A1828', marginBottom: 16 }}>
            Thank You
          </div>
          <div style={{ ...sans, fontSize: 15, color: '#0A1828', lineHeight: 1.6 }}>
            Your intake form has been submitted successfully.<br />
            Your advisor has been notified.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#FAFAF8' }}>
      <header style={{
        background: '#FFFFFF', borderBottom: '1px solid rgba(7,25,42,0.08)',
        padding: '16px 24px', textAlign: 'center',
      }}>
        <div style={{
          ...mono, fontSize: 9, letterSpacing: '0.28em',
          color: '#7A5230', textTransform: 'uppercase', marginBottom: 2,
        }}>
          CORDIS GROUP
        </div>
        <div style={{ ...serif, fontSize: 22, fontWeight: 300, color: '#0A1828' }}>
          Intake Form
        </div>
        {eng && (eng.company || eng.client_name) && (
          <div style={{ ...sans, fontSize: 14, color: '#7A94A8', marginTop: 4 }}>
            {eng.company || eng.client_name}
          </div>
        )}
      </header>

      <div style={{ padding: '24px 24px 80px', maxWidth: 640, margin: '0 auto' }}>
        <div style={{
          background: '#FFFFFF', border: '1px solid rgba(7,25,42,0.10)',
          padding: 24,
        }}>
          <div style={{
            ...mono, fontSize: 7.5, letterSpacing: '0.22em', textTransform: 'uppercase',
            color: '#7A5230', marginBottom: 16,
            display: 'flex', alignItems: 'center', gap: 12,
          }}>
            <span style={{ width: 20, height: 1, background: '#7A5230', flexShrink: 0 }} />
            INTAKE FORM
          </div>
          <IntakeFormFields
            initialValues={eng.intake_form_answers || {}}
            onSubmit={handleSubmit}
          />
        </div>
      </div>

      <div style={{
        position: 'fixed', bottom: 0, left: 0, right: 0,
        textAlign: 'center', padding: '12px 0', background: '#FAFAF8',
        borderTop: '1px solid rgba(7,25,42,0.06)',
        ...mono, fontSize: 9, letterSpacing: '0.16em',
        color: '#7A94A8', textTransform: 'uppercase',
      }}>
        Cordis Group &middot; Confidential
      </div>
    </div>
  );
}
